<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: Reload (with countdown timer)
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=4000-54515
 */
import type { ButtonReloadProps } from '../types/interfaces'

import { faArrowRotateRight } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'

import { useButtonReload } from '../composables/use-button-reload.hook'

defineOptions({
  name: 'ButtonReload',
})

const props = withDefaults(defineProps<ButtonReloadProps>(), {
  disabled: false,
  onClick: undefined,
})

const emit = defineEmits<{
  loading: [value: boolean]
}>()

const {
  time,
  isDisabled,
  handleClick,
} = useButtonReload({
  props,
  onLoading: (value) => emit('loading', value),
})
</script>

<template>
  <button
    type="button"
    :class="['ui-button-reload', { 'is-disabled': isDisabled }]"
    :disabled="isDisabled"
    @click="handleClick"
  >
    <AppText
      name="body2-medium"
      align="center"
      color="slate-400"
      class="ui-button-reload__text"
    >
      {{ time }}
    </AppText>
    <AppIcon
      :icon="faArrowRotateRight"
      size="big"
      class="ui-button-reload__icon"
    />
  </button>
</template>

<style lang="scss" scoped src="../styles/_button-reload.scss" />
